import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import guidanceImage from '../../../assets/images/guidance.png';
import styles from '../WhySellAtCatawiki.module.scss';

export const ExpertBlock = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.keyPointsBlock}>
      <div className="tw:relative">
        <Image
          width={305}
          height={240}
          src={guidanceImage}
          unoptimized
          alt="experts_illustration"
        />
      </div>

      <h3 className="u-typography-h3 u-m-t-xxl-4">
        {t('seller_register.why.experts_title')}
      </h3>
      <h5 className="u-typography-h5 u-m-t-m u-color-secondary">
        {t('seller_register.why.experts_subtitle')}
      </h5>
    </div>
  );
};
